export default {
  primary: '#00bfa5',
  primaryLight: '#e0f2f1',
  secondary: '#039be5',
  secondaryLight: '#e1f5fe',
  info: '#3949ab',
  warning: '#ffb300',
  success: '#43a047',
  error: '#e53935',
  accent: '#ffd840',
}
